import { Box, Container, Link, SimpleGrid, Text } from "@chakra-ui/react";
import { Tweet } from "react-twitter-widgets";

import analyticsInstance from "../config/analytics";

export default function StreetCred() {
  return (
    <Box as="section" bgColor="lightblue" py="4em" px="1em" textAlign="center">
      <Text fontSize="4xl" mb="1em">
        👀 As seen in
      </Text>

      <SimpleGrid columns={{ base: 1, sm: 1, md: 2, lg: 3 }} gap={1} mt="1em">
        <Container>
          <Link
            href="https://twitter.com/ETHGlobal/status/1529576980873617410"
            isExternal={true}
            fontSize="large"
            display="block"
            onClick={() => analyticsInstance.track("StreetCredClicked")}
          >
            HackMoney 2022 Finalist
          </Link>
          <Tweet tweetId="1529689340183465985" options={{ conversation: "none" }} />
        </Container>

        <Container>
          <Link
            href="https://twitter.com/encodeclub/status/1546919565212487682"
            isExternal={true}
            fontSize="large"
            display="block"
            onClick={() => analyticsInstance.track("StreetCredClicked")}
          >
            Encode x Polygon Hackathon 2022 Open Track Challenge Winner
          </Link>
          <Tweet tweetId="1546919565212487682" options={{ conversation: "none" }} />
        </Container>

        <Container>
          <Link
            href="https://twitter.com/Superfluid_HQ/status/1621447000460853255"
            isExternal={true}
            fontSize="large"
            display="block"
            onClick={() => analyticsInstance.track("StreetCredClicked")}
          >
            Superfluid Wave Pool #5 - 2nd Place Winner
          </Link>
          <Tweet tweetId="1621447000460853255" options={{ conversation: "none" }} />
        </Container>
      </SimpleGrid>
    </Box>
  );
}
